import colors from '@constants/colors';
import { numberRegexp, phoneFormat, phoneRegExp } from '@constants/regexp';
import { ChangeEvent, useContext, useMemo } from 'react';

import useSms from './useSms';
import useVerification from './useVerification';
import SignUpContext from '../../../context/SignUpContext';

const ENABLED_COLOR = 'var(--color-blue)';
const SUCCESS_COLOR = 'var(--color-green)';
function useCertification() {
  const {
    usePhoneNo, useInputPhoneNo, useVerified, useInputSmsAuthCode,
  } = useContext(SignUpContext);
  const [phoneNo, setPhoneNo] = useInputPhoneNo;
  const [certPhoneNo, setCertPhoneNo] = usePhoneNo;
  const [isVerified, setVerified] = useVerified;
  const [smsAuthNo, setSmsAuthNo] = useInputSmsAuthCode;
  const requestColor = certPhoneNo ? SUCCESS_COLOR : ENABLED_COLOR;
  const verityColor = useMemo<string>(() => {
    if (isVerified) {
      return SUCCESS_COLOR;
    }
    if (certPhoneNo) {
      return ENABLED_COLOR;
    }
    return colors.gray5;
  }, [isVerified, certPhoneNo]);
  const onChangePhone = (e: ChangeEvent<HTMLInputElement>) => {
    setVerified(false);
    setCertPhoneNo('');
    setPhoneNo(e.target.value.replace(numberRegexp, '')
      .replace(phoneRegExp, phoneFormat));
  };
  const onChangeCode = (e: ChangeEvent<HTMLInputElement>) => {
    setSmsAuthNo(e.target.value.replace(numberRegexp, ''));
  };
  const requestSms = useSms({ phoneNo });
  const requestVerify = useVerification({ smsAuthNo });

  return {
    requestColor,
    verityColor,
    phoneNo,
    onChangePhone,
    code: smsAuthNo,
    onChangeCode,
    certPhoneNo,
    isVerified,
    requestVerify,
    requestSms,
  };
}

export default useCertification;
